import DemoAccountsTableItem from './DemoAccountsTableItem'

export default DemoAccountsTableItem
